import { createSelector } from '@ngrx/store';
import { isMissing } from '@imcc/utilities';
import { selectIntroductionState } from './select-introduction-state';
import { IntroductionState } from './introduction-state';

export const selectShowIntroduction = createSelector(
  selectIntroductionState,
  (state: IntroductionState) => {
    if (isMissing(state.dismissedAt)) {
      return true;
    }

    return state.dismissedAt >= new Date();
  },
);
